import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SheetsAppContextDirective } from '@modules/sheets/directives/app-sheets-app-context.directive';
import { Sheet } from '@modules/sheets/types/sheet';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-sheet-shared',
  templateUrl: './sheet-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SheetsAppContextDirective,
    IconComponent,
    FormControlsModule,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
  ],
})
export class SheetSharedComponent extends SharedBaseComponent<Sheet> {
  protected override readonly stitchType = StitchType.SHEET;

  protected get sheet(): Sheet {
    return this.stitchItem?.();
  }
}
